import { validateUniqueValue } from "utils/formValidators";

export const MAX_HOSTS = 50;

export const EMPTY_VALUE = { value: "" };

export type OauthRedirectAllowlistFormFields = {
  hosts: { value: string }[];
};

export const validateUniqueHost =
  (index: number) =>
  (value: string, { hosts }: OauthRedirectAllowlistFormFields) => {
    const otherHosts = hosts.reduce<string[]>((acc, host, hostIndex) => {
      const normalized = host.value.toLowerCase();

      if (hostIndex !== index && normalized) {
        acc.push(normalized);
      }

      return acc;
    }, []);

    return validateUniqueValue(otherHosts, "Host must be unique")(value.toLowerCase());
  };

export const getFilledHosts = (hosts: OauthRedirectAllowlistFormFields["hosts"]) =>
  hosts.map((entry) => entry.value.trim()).filter(Boolean);

export const getFormDefaultValues = (
  currentHosts: string[] | undefined
): OauthRedirectAllowlistFormFields => ({
  hosts:
    currentHosts && currentHosts.length > 0
      ? currentHosts.map((value) => ({ value }))
      : [EMPTY_VALUE],
});
